/**
  This is the home location for all pages, with or without restaurant
 */
const buildRoot = (tenantId, restaurantId) => {
  if (!restaurantId) return `${tenantId}`;
  return `${tenantId}/restaurants/${restaurantId}`; // doesn't have slash before or after!
};

export default buildRoot;
